// Centralized mapping for IFI Job Paperwork template types.
// This reduces drift between template dropdown options and warning display labels.

export const JOB_PAPERWORK_TEMPLATE_LABELS = {
  window_worksheet: 'Window Worksheet',
  entry_door_worksheet: 'Entry Door Worksheet',
  storm_door_worksheet: 'Storm Door Worksheet',
  interior_door_worksheet: 'Interior Door Worksheet',
  workorder_inspection: 'Workorder Inspection',
};

export const JOB_PAPERWORK_TEMPLATE_OPTIONS = {
  Assessment: [
    { value: 'window_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.window_worksheet },
    { value: 'entry_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.entry_door_worksheet },
    { value: 'storm_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.storm_door_worksheet },
    { value: 'interior_door_worksheet', label: JOB_PAPERWORK_TEMPLATE_LABELS.interior_door_worksheet },
  ],
  Workorder: [
    { value: 'workorder_inspection', label: JOB_PAPERWORK_TEMPLATE_LABELS.workorder_inspection },
  ],
};




// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/jobPaperworkTemplateTypes.js